import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-space-y-5" }
const _hoisted_2 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_3 = { class: "tw-p-5" }
const _hoisted_4 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4" }
const _hoisted_5 = {
  key: 0,
  class: "lg:tw-col-span-3"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-700"
}
const _hoisted_7 = {
  key: 1,
  class: "lg:tw-col-span-4"
}
const _hoisted_8 = { class: "tw-mb-1 tw-flex tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 2,
  class: "tw-mt-2 tw-text-xs"
}
const _hoisted_11 = {
  key: 0,
  class: "tw-text-amber-700"
}
const _hoisted_12 = {
  key: 1,
  class: "tw-text-emerald-700"
}
const _hoisted_13 = {
  key: 2,
  class: "tw-text-slate-700"
}
const _hoisted_14 = {
  key: 3,
  class: "tw-text-indigo-700"
}
const _hoisted_15 = {
  key: 2,
  class: "lg:tw-col-span-3"
}
const _hoisted_16 = {
  key: 3,
  class: "lg:tw-col-span-3"
}
const _hoisted_17 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_18 = { class: "tw-p-5" }
const _hoisted_19 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4" }
const _hoisted_20 = {
  key: 0,
  class: "lg:tw-col-span-4"
}
const _hoisted_21 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-700"
}
const _hoisted_22 = {
  key: 1,
  class: "tw-mt-2 tw-text-xs tw-text-slate-600"
}
const _hoisted_23 = { class: "lg:tw-col-span-4" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-700"
}
const _hoisted_26 = {
  key: 1,
  class: "tw-mt-2"
}
const _hoisted_27 = {
  key: 2,
  class: "tw-mt-2 tw-text-xs tw-text-slate-600"
}
const _hoisted_28 = {
  key: 1,
  class: "tw-space-y-3"
}
const _hoisted_29 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_30 = { class: "sm:tw-col-span-2" }
const _hoisted_31 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_32 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_33 = { class: "tw-flex tw-justify-end tw-gap-2" }
const _hoisted_34 = {
  key: 1,
  class: "lg:tw-col-span-4"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-700"
}
const _hoisted_37 = {
  key: 1,
  class: "tw-mt-2"
}
const _hoisted_38 = {
  key: 2,
  class: "tw-mt-2 tw-text-xs tw-text-slate-600"
}
const _hoisted_39 = {
  key: 1,
  class: "tw-space-y-3"
}
const _hoisted_40 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_41 = { class: "sm:tw-col-span-2" }
const _hoisted_42 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_43 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_44 = { class: "tw-flex tw-justify-end tw-gap-2" }
const _hoisted_45 = {
  key: 0,
  class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-sm tw-shadow-slate-900/5"
}
const _hoisted_46 = { class: "tw-p-5" }
const _hoisted_47 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4" }
const _hoisted_48 = { class: "lg:tw-col-span-4" }
const _hoisted_49 = { class: "lg:tw-col-span-4" }
const _hoisted_50 = { class: "lg:tw-col-span-4" }
const _hoisted_51 = {
  key: 1,
  class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-sm tw-shadow-slate-900/5"
}
const _hoisted_52 = { class: "tw-p-5" }
const _hoisted_53 = {
  key: 0,
  class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4"
}
const _hoisted_54 = { class: "lg:tw-col-span-4" }
const _hoisted_55 = { class: "lg:tw-col-span-4" }
const _hoisted_56 = { class: "tw-flex tw-items-end tw-gap-2" }
const _hoisted_57 = { class: "tw-flex-1" }
const _hoisted_58 = { class: "lg:tw-col-span-4" }
const _hoisted_59 = {
  key: 1,
  class: "tw-space-y-4"
}
const _hoisted_60 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4" }
const _hoisted_61 = { class: "lg:tw-col-span-3" }
const _hoisted_62 = { class: "lg:tw-col-span-3" }
const _hoisted_63 = { class: "lg:tw-col-span-3" }
const _hoisted_64 = { class: "lg:tw-col-span-3" }
const _hoisted_65 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4" }
const _hoisted_66 = { class: "lg:tw-col-span-4" }
const _hoisted_67 = { class: "lg:tw-col-span-4" }
const _hoisted_68 = { class: "lg:tw-col-span-4" }
const _hoisted_69 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_70 = { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }
const _hoisted_71 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_72 = { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_73 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_74 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_75 = { class: "tw-p-5" }
const _hoisted_76 = {
  key: 0,
  class: "tw-mb-3 tw-text-xs tw-text-rose-700"
}
const _hoisted_77 = {
  key: 1,
  class: "tw-mb-3 tw-text-xs tw-text-rose-700"
}
const _hoisted_78 = {
  key: 2,
  class: "tw-overflow-x-hidden"
}
const _hoisted_79 = { class: "tw-w-full tw-table-fixed tw-text-left tw-text-sm" }
const _hoisted_80 = { class: "tw-text-xs tw-uppercase tw-tracking-wide tw-text-slate-500" }
const _hoisted_81 = {
  key: 0,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_82 = {
  key: 1,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_83 = {
  key: 2,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_84 = {
  key: 3,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_85 = {
  key: 4,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_86 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_87 = { class: "tw-px-3 tw-py-2 tw-min-w-0" }
const _hoisted_88 = ["value", "onInput"]
const _hoisted_89 = {
  key: 1,
  class: "tw-text-slate-800"
}
const _hoisted_90 = { class: "tw-px-3 tw-py-2 tw-min-w-0" }
const _hoisted_91 = {
  key: 0,
  class: "tw-text-slate-800"
}
const _hoisted_92 = { class: "tw-px-3 tw-py-2 tw-min-w-0" }
const _hoisted_93 = {
  key: 0,
  class: "tw-text-slate-800"
}
const _hoisted_94 = { class: "tw-px-3 tw-py-2 tw-min-w-0" }
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = {
  key: 0,
  class: "tw-px-3 tw-py-2 tw-min-w-0"
}
const _hoisted_97 = ["onUpdate:modelValue"]
const _hoisted_98 = {
  key: 1,
  class: "tw-px-3 tw-py-2 tw-min-w-0"
}
const _hoisted_99 = ["onUpdate:modelValue"]
const _hoisted_100 = {
  key: 2,
  class: "tw-px-3 tw-py-2 tw-min-w-0"
}
const _hoisted_101 = ["onUpdate:modelValue"]
const _hoisted_102 = {
  key: 3,
  class: "tw-px-3 tw-py-2 tw-min-w-0"
}
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = {
  key: 4,
  class: "tw-px-3 tw-py-2 tw-min-w-0"
}
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = { class: "tw-px-3 tw-py-2 tw-text-right" }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = {
  key: 0,
  class: "tw-bg-slate-50/40"
}
const _hoisted_109 = ["colspan"]
const _hoisted_110 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-overflow-hidden" }
const _hoisted_111 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "tw-overflow-x-auto" }
const _hoisted_114 = { class: "tw-min-w-full tw-text-left tw-text-sm" }
const _hoisted_115 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_116 = { class: "tw-px-3 tw-py-2 tw-min-w-[110px]" }
const _hoisted_117 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_118 = { class: "tw-px-3 tw-py-2 tw-min-w-[110px]" }
const _hoisted_119 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_120 = { class: "tw-px-3 tw-py-2 tw-min-w-[240px]" }
const _hoisted_121 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_122 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_123 = { class: "tw-px-3 tw-py-2 tw-text-right" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = {
  key: 3,
  class: "tw-overflow-x-auto"
}
const _hoisted_126 = { class: "tw-min-w-full tw-text-left tw-text-sm" }
const _hoisted_127 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_128 = { class: "tw-px-3 tw-py-2 tw-min-w-[110px]" }
const _hoisted_129 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_130 = { class: "tw-px-3 tw-py-2 tw-min-w-[110px]" }
const _hoisted_131 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_132 = { class: "tw-px-3 tw-py-2 tw-min-w-[240px]" }
const _hoisted_133 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_134 = { class: "tw-px-3 tw-py-2 tw-min-w-[140px]" }
const _hoisted_135 = { class: "tw-px-3 tw-py-2 tw-text-right" }
const _hoisted_136 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_EditVessel = _resolveComponent("EditVessel")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }, [
        _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Reference")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isOceanExport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_InputField, {
                  id: "bkgNumber",
                  label: "Booking Number",
                  modelValue: _ctx.orderData.bookingNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.bookingNumber) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.fieldErrors.bookingNumber)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.fieldErrors.bookingNumber), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.isOceanImport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[53] || (_cache[53] = _createElementVNode("label", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Bill of Lading Number", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700 hover:tw-bg-slate-50",
                      title: _ctx.isManualBLMode ? 'Switch to BL search mode' : 'Switch to manual BL entry',
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleBLMode && _ctx.toggleBLMode(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.isManualBLMode ? 'magnifying-glass' : 'pen',
                        class: "tw-h-3 tw-w-3"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.isManualBLMode ? 'Search' : 'Manual'), 1)
                    ], 8, _hoisted_9)
                  ]),
                  (!_ctx.isManualBLMode)
                    ? (_openBlock(), _createBlock(_component_FilterableDropdown, {
                        key: 0,
                        placeholder: "search for BL number",
                        size: "sm",
                        modelValue: _ctx.orderData.billOfLadingNumber,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.billOfLadingNumber) = $event)),
                          _ctx.selectBL
                        ],
                        options: _ctx.mappedBLs,
                        clearable: true,
                        searchable: true,
                        onSearchChange: _ctx.onBLSearch
                      }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "onSearchChange"]))
                    : (_openBlock(), _createBlock(_component_InputField, {
                        key: 1,
                        id: "BillOfLadingNumberManual",
                        label: "",
                        modelValue: _ctx.orderData.billOfLadingNumber,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderData.billOfLadingNumber) = $event)),
                        placeholder: "enter new/custom BL number"
                      }, null, 8, ["modelValue"])),
                  (_ctx.orderData.billOfLadingNumber && String(_ctx.orderData.billOfLadingNumber).length > 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.blStatus?.hasOrder)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Bill of Lading already has an order and cannot be used to create a new order "))
                          : (_ctx.blStatus?.inCompany && _ctx.doesBLExist)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Already Tracking " + _toDisplayString(_ctx.activeBLs[_ctx.mappedBLs.indexOf(_ctx.orderData.billOfLadingNumber)].containers.length) + " containers for BL ", 1))
                            : (_ctx.blStatus?.inCompany && !_ctx.doesBLExist)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Bill of Lading exists for your company "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_14, " Bill of Lading does not exist, will create a new Bill of Lading " + _toDisplayString(_ctx.orderData.billOfLadingNumber), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.referenceColClass)
          }, [
            _createVNode(_component_InputField, {
              id: "CustomerRef",
              label: "Customer Reference #",
              modelValue: _ctx.orderData.customerReference,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderData.customerReference) = $event))
            }, null, 8, ["modelValue"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.referenceColClass)
          }, [
            _createVNode(_component_InputField, {
              id: "BillingRef",
              label: "Billing Reference #",
              modelValue: _ctx.orderData.billingCustomerReference,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderData.billingCustomerReference) = $event))
            }, null, 8, ["modelValue"])
          ], 2),
          (_ctx.settingsOrderShowLinkedOrderNumberField)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_InputField, {
                  id: "LinkedOrderNumber",
                  label: "Linked Master Order #",
                  modelValue: _ctx.orderData.linkedMasterOrderNumber,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderData.linkedMasterOrderNumber) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showBrokerFields)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_InputField, {
                  id: "HouseBillOfLading",
                  label: "House Bill of Lading Number",
                  modelValue: _ctx.orderData.houseBillOfLading,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderData.houseBillOfLading) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_EditVessel, {
      isOpen: _ctx.showAddVesselModal,
      "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showAddVesselModal) = $event)),
      onClose: _ctx.closeAddVesselModal,
      onSaved: _ctx.onAddVesselSaved
    }, null, 8, ["isOpen", "onClose", "onSaved"]),
    _createElementVNode("div", _hoisted_17, [
      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }, [
        _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Locations")
      ], -1)),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_ctx.showPickUp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_FilterableDropdown, {
                  textLabel: _ctx.pickUpLabel,
                  placeholder: _ctx.pickUpPlaceholder,
                  size: "sm",
                  modelValue: _ctx.orderData.pickUpLocation,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderData.pickUpLocation) = $event)),
                  customLabel: (x) => (x.shortName ? x.shortName : x.name),
                  options: _ctx.pickUpOptions,
                  class: "tw-w-full",
                  onSearchChange: _ctx.onReceivingCustomerSearch
                }, null, 8, ["textLabel", "placeholder", "modelValue", "customLabel", "options", "onSearchChange"]),
                (_ctx.fieldErrors.pickUpLocation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.fieldErrors.pickUpLocation), 1))
                  : _createCommentVNode("", true),
                (_ctx.orderData.pickUpLocation?.deliveryAddress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.orderData.pickUpLocation.deliveryAddress.streetAddress), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.addressLine3(_ctx.orderData.pickUpLocation.deliveryAddress)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            (!_ctx.isAddingNewDropoff)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_FilterableDropdown, {
                    textLabel: _ctx.dropOffLabel,
                    placeholder: _ctx.dropOffPlaceholder,
                    size: "sm",
                    modelValue: _ctx.orderData.dropOffLocation,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderData.dropOffLocation) = $event)),
                    customLabel: (x) => (x.displayName ? x.displayName : x.name),
                    options: _ctx.receivingCustomers || [],
                    class: "tw-w-full",
                    onSearchChange: _ctx.onReceivingCustomerSearch
                  }, null, 8, ["textLabel", "placeholder", "modelValue", "customLabel", "options", "onSearchChange"]),
                  (_ctx.fieldErrors.dropOffLocation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.fieldErrors.dropOffLocation), 1))
                    : _createCommentVNode("", true),
                  (_ctx.canCreateReceiver)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.createReceiver && _ctx.createReceiver(...args)))
                        }, " Create receiver " + _toDisplayString(_ctx.receivingCustomerQuery), 1)
                      ]))
                    : (_ctx.orderData.dropOffLocation?.deliveryAddress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.orderData.dropOffLocation.deliveryAddress.streetAddress), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.addressLine3(_ctx.orderData.dropOffLocation.deliveryAddress)), 1)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_InputField, {
                        id: "streetAddReceiving",
                        label: "Street Address",
                        modelValue: _ctx.newDropoff.streetAddress,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newDropoff.streetAddress) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_InputField, {
                        id: "suitNumberReceiving",
                        label: "Suite #",
                        modelValue: _ctx.newDropoff.suite,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newDropoff.suite) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_InputField, {
                      id: "cityReceiving",
                      label: "City",
                      modelValue: _ctx.newDropoff.city,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newDropoff.city) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputField, {
                      id: "stateReceiving",
                      label: "State",
                      modelValue: _ctx.newDropoff.state,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newDropoff.state) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputField, {
                      id: "zipReceiving",
                      label: "Zip",
                      modelValue: _ctx.newDropoff.zipCode,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newDropoff.zipCode) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_InputField, {
                      id: "contactEmailReceiving",
                      label: "Email",
                      modelValue: _ctx.newContact.email,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newContact.email) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputField, {
                      id: "contactNameReceiving",
                      label: "Name",
                      modelValue: _ctx.newContact.name,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newContact.name) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputField, {
                      id: "contactPhoneReceiving",
                      label: "Phone Number",
                      modelValue: _ctx.newContact.phoneNumber,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newContact.phoneNumber) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.cancelReceiverCreate && _ctx.cancelReceiverCreate(...args)))
                    }, " Cancel "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.confirmReceiverAddition && _ctx.confirmReceiverAddition(...args)))
                    }, " Save receiver " + _toDisplayString(_ctx.receivingCustomerQuery), 1)
                  ])
                ]))
          ]),
          (!_ctx.isAddingNewDropoff)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (!_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_FilterableDropdown, {
                        textLabel: "Bill To",
                        placeholder: "Billing Customer",
                        size: "sm",
                        modelValue: _ctx.orderData.billTo,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orderData.billTo) = $event)),
                        customLabel: (x) => (x.displayName ? x.displayName : x.name),
                        options: _ctx.billingCustomers || [],
                        class: "tw-w-full",
                        onSearchChange: _ctx.onBillingCustomerSearch
                      }, null, 8, ["modelValue", "customLabel", "options", "onSearchChange"]),
                      (_ctx.fieldErrors.billTo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.fieldErrors.billTo), 1))
                        : _createCommentVNode("", true),
                      (_ctx.canCreateBillTo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.createBillTo && _ctx.createBillTo(...args)))
                            }, " Create customer " + _toDisplayString(_ctx.billingCustomerQuery), 1)
                          ]))
                        : (_ctx.orderData.billTo?.billingAddress)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.orderData.billTo.billingAddress.streetAddress), 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.addressLine3(_ctx.orderData.billTo.billingAddress)), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_InputField, {
                            id: "streetAddBillTo",
                            label: "Street Address",
                            modelValue: _ctx.newBillTo.streetAddress,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newBillTo.streetAddress) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_InputField, {
                            id: "suiteNumberBillTo",
                            label: "Suite #",
                            modelValue: _ctx.newBillTo.suite,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newBillTo.suite) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_InputField, {
                          id: "cityBillTo",
                          label: "City",
                          modelValue: _ctx.newBillTo.city,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newBillTo.city) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputField, {
                          id: "stateBillTo",
                          label: "State",
                          modelValue: _ctx.newBillTo.state,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newBillTo.state) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputField, {
                          id: "zipBillTo",
                          label: "Zip",
                          modelValue: _ctx.newBillTo.zipCode,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.newBillTo.zipCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_InputField, {
                          id: "contactEmailBillTo",
                          label: "Email",
                          modelValue: _ctx.newContact.email,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newContact.email) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputField, {
                          id: "contactNameBillTo",
                          label: "Name",
                          modelValue: _ctx.newContact.name,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.newContact.name) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_InputField, {
                          id: "contactPhoneBillTo",
                          label: "Phone Number",
                          modelValue: _ctx.newContact.phoneNumber,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.newContact.phoneNumber) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                          onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.cancelBillToCreate && _ctx.cancelBillToCreate(...args)))
                        }, " Cancel "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                          onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.confirmBillToAddition && _ctx.confirmBillToAddition(...args)))
                        }, " Save customer " + _toDisplayString(_ctx.billingCustomerQuery), 1)
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.settingsOrderShowEmergencyInformation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }, [
            _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Emergency / Carrier")
          ], -1)),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_InputField, {
                  id: "orderCarrierName",
                  label: "Carrier Name",
                  modelValue: _ctx.orderData.carrierName,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.orderData.carrierName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_InputField, {
                  id: "scacCode",
                  label: "SCAC",
                  modelValue: _ctx.orderData.scacCode,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.orderData.scacCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_InputField, {
                  id: "EmergencyPhoneNumber",
                  label: "Emergency Response Phone Number",
                  modelValue: _ctx.orderData.emergencyResponsePhoneNumber,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.orderData.emergencyResponsePhoneNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowShipLineInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }, [
            _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Sailing / Ship Line")
          ], -1)),
          _createElementVNode("div", _hoisted_52, [
            (!_ctx.showBrokerFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_FilterableDropdown, {
                      textLabel: "Steamship Line",
                      placeholder: "Steamship Line",
                      size: "sm",
                      modelValue: _ctx.orderData.shipLineInfo.line,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.orderData.shipLineInfo.line) = $event)),
                      options: _ctx.steamshipLines
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_FilterableDropdown, {
                          textLabel: "Vessel Name",
                          placeholder: "Vessel",
                          size: "sm",
                          modelValue: _ctx.orderData.shipLineInfo.vessel,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.orderData.shipLineInfo.vessel) = $event)),
                          options: _ctx.filteredVessels,
                          onSearchChange: _ctx.onVesselSearch
                        }, null, 8, ["modelValue", "options", "onSearchChange"])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "tw-h-10 tw-shrink-0 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                        onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.openAddVesselModal && _ctx.openAddVesselModal(...args)))
                      }, " Add ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_DatePicker, {
                      textLabel: _ctx.isOceanImport ? 'ETA' : 'Vessel Cut Off / LRD',
                      format: "MM/DD/YYYY",
                      modelValue: _ctx.orderData.shipLineInfo.eta,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.orderData.shipLineInfo.eta) = $event))
                    }, null, 8, ["textLabel", "modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_InputField, {
                        label: "Port of Loading",
                        modelValue: _ctx.orderData.brokerSailingInfo.portOfLoading,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.portOfLoading) = $event)),
                        id: "portOfLoading"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_InputField, {
                        label: "Port of Discharge",
                        modelValue: _ctx.orderData.brokerSailingInfo.portOfDischarge,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.portOfDischarge) = $event)),
                        id: "portOfDischarge"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_InputField, {
                        label: "Place of Receipt",
                        modelValue: _ctx.orderData.brokerSailingInfo.placeOfReceipt,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.placeOfReceipt) = $event)),
                        id: "placeOfReceipt"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_InputField, {
                        label: "Place of Delivery",
                        modelValue: _ctx.orderData.brokerSailingInfo.placeOfDelivery,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.placeOfDelivery) = $event)),
                        id: "placeOfDelivery"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_InputField, {
                        label: "Vessel / Voyage",
                        modelValue: _ctx.orderData.brokerSailingInfo.vesselVoyage,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.vesselVoyage) = $event)),
                        id: "vesselVoyage"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_InputField, {
                        label: "Sailing Date",
                        modelValue: _ctx.orderData.brokerSailingInfo.sailingDate,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.sailingDate) = $event)),
                        id: "sailingDate"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(_component_InputField, {
                        label: "Arrival Date",
                        modelValue: _ctx.orderData.brokerSailingInfo.arrivalDate,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.arrivalDate) = $event)),
                        id: "arrivalDate"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.isLandOrder ? 'Loads' : 'Containers'), 1),
          (!_ctx.isLandOrder)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "tw-inline-flex tw-items-center tw-rounded-lg tw-w-auto tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                    onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.quickAddContainers && _ctx.quickAddContainers(...args)))
                  }, " Add "),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.quickAddContainerCount) = $event)),
                    type: "number",
                    min: "1",
                    max: "50",
                    step: "1",
                    class: "tw-w-20 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                    "aria-label": "Number of containers",
                    placeholder: "Qty"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.quickAddContainerCount,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createVNode(_component_FilterableDropdown, {
                    modelValue: _ctx.quickAddSizeType,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.quickAddSizeType) = $event)),
                    size: "sm",
                    placeholder: "Size/Type",
                    clearable: false,
                    searchable: true,
                    options: _ctx.containerSizeTypeOptions
                  }, null, 8, ["modelValue", "options"])
                ]),
                _cache[58] || (_cache[58] = _createTextVNode("       ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                  onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.addContainer && _ctx.addContainer(...args)))
                }, " Add Blank Container ")
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.addFreightContents(0)))
              }, " Add Load Item "))
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        (_ctx.quickAddError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.quickAddError), 1))
          : _createCommentVNode("", true),
        (_ctx.fieldErrors.containers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.fieldErrors.containers), 1))
          : _createCommentVNode("", true),
        (!_ctx.isLandOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _createElementVNode("table", _hoisted_79, [
                _createElementVNode("thead", _hoisted_80, [
                  _createElementVNode("tr", null, [
                    _cache[59] || (_cache[59] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Container #", -1)),
                    _cache[60] || (_cache[60] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Length", -1)),
                    _cache[61] || (_cache[61] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Type", -1)),
                    _cache[62] || (_cache[62] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Seal #", -1)),
                    (!_ctx.settingsOrderLtlEnabled)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_81, "Cargo Pieces"))
                      : _createCommentVNode("", true),
                    (_ctx.isRailPickUp)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_82, "Pick-Up #"))
                      : (_ctx.isRailDropOff)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_83, "Release #"))
                        : _createCommentVNode("", true),
                    (!_ctx.settingsOrderLtlEnabled)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_84, "Description"))
                      : _createCommentVNode("", true),
                    (!_ctx.settingsOrderLtlEnabled)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_85, "Weight"))
                      : _createCommentVNode("", true),
                    _cache[63] || (_cache[63] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.containers, (container, containerIdx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: containerIdx }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_87, [
                          (container.isAdded)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                placeholder: "Container",
                                value: container.containerId && container.containerId.toUpperCase(),
                                onInput: ($event: any) => (container.containerId = String(($event.target as HTMLInputElement).value).toUpperCase())
                              }, null, 40, _hoisted_88))
                            : (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(container.containerId), 1))
                        ]),
                        _createElementVNode("td", _hoisted_90, [
                          (container.sizeType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(container.sizeType), 1))
                            : (_openBlock(), _createBlock(_component_FilterableDropdown, {
                                key: 1,
                                placeholder: "Size",
                                size: "sm",
                                clearable: false,
                                modelValue: container.size,
                                "onUpdate:modelValue": ($event: any) => ((container.size) = $event),
                                options: _ctx.containerSizes
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        ]),
                        _createElementVNode("td", _hoisted_92, [
                          (container.sizeType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(container.sizeType), 1))
                            : (_openBlock(), _createBlock(_component_FilterableDropdown, {
                                key: 1,
                                placeholder: "Type",
                                size: "sm",
                                clearable: false,
                                modelValue: container.type,
                                "onUpdate:modelValue": ($event: any) => ((container.type) = $event),
                                options: _ctx.containerTypesValues
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        ]),
                        _createElementVNode("td", _hoisted_94, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                            placeholder: "Seal",
                            "onUpdate:modelValue": ($event: any) => ((container.sealNumber) = $event)
                          }, null, 8, _hoisted_95), [
                            [_vModelText, container.sealNumber]
                          ])
                        ]),
                        (!_ctx.settingsOrderLtlEnabled)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_96, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                placeholder: "Pieces",
                                "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].quantity) = $event)
                              }, null, 8, _hoisted_97), [
                                [_vModelText, container.freightContents[0].quantity]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isRailPickUp)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_98, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                placeholder: "Pick-Up #",
                                "onUpdate:modelValue": ($event: any) => ((container.pickupNumber) = $event)
                              }, null, 8, _hoisted_99), [
                                [_vModelText, container.pickupNumber]
                              ])
                            ]))
                          : (_ctx.isRailDropOff)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_100, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                  placeholder: "Release #",
                                  "onUpdate:modelValue": ($event: any) => ((container.releaseNumber) = $event)
                                }, null, 8, _hoisted_101), [
                                  [_vModelText, container.releaseNumber]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                        (!_ctx.settingsOrderLtlEnabled)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_102, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                placeholder: "Description",
                                "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].description) = $event)
                              }, null, 8, _hoisted_103), [
                                [_vModelText, container.freightContents[0].description]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.settingsOrderLtlEnabled)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_104, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
                                placeholder: "Weight",
                                "onUpdate:modelValue": ($event: any) => ((container.freightContents[0].weight) = $event)
                              }, null, 8, _hoisted_105), [
                                [_vModelText, container.freightContents[0].weight]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_106, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-h-9 tw-w-9 tw-text-slate-600 hover:tw-bg-slate-50",
                            "aria-label": "Remove container",
                            onClick: ($event: any) => (_ctx.removeContainer(containerIdx))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "trash",
                              class: "tw-h-4 tw-w-4"
                            })
                          ], 8, _hoisted_107)
                        ])
                      ]),
                      (_ctx.settingsOrderLtlEnabled)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_108, [
                            _createElementVNode("td", {
                              colspan: _ctx.ltlColSpan,
                              class: "tw-px-3 tw-py-3"
                            }, [
                              _createElementVNode("div", _hoisted_110, [
                                _createElementVNode("div", _hoisted_111, [
                                  _cache[64] || (_cache[64] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Freight Contents", -1)),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
                                    onClick: ($event: any) => (_ctx.addFreightContents(containerIdx))
                                  }, " Add Freight Content ", 8, _hoisted_112)
                                ]),
                                _createElementVNode("div", _hoisted_113, [
                                  _createElementVNode("table", _hoisted_114, [
                                    _cache[65] || (_cache[65] = _createElementVNode("thead", { class: "tw-text-xs tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Qty"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Packing Type"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Hazmat"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Weight"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Description"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "NMFC #"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Class"),
                                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" })
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", _hoisted_115, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(container.freightContents, (fc, fcIdx) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: fcIdx }, [
                                          _createElementVNode("td", _hoisted_116, [
                                            _createVNode(_component_InputField, {
                                              id: "Quantity",
                                              modelValue: fc.quantity,
                                              "onUpdate:modelValue": ($event: any) => ((fc.quantity) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_117, [
                                            _createVNode(_component_InputField, {
                                              id: "PackingType",
                                              modelValue: fc.packingType,
                                              "onUpdate:modelValue": ($event: any) => ((fc.packingType) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_118, [
                                            _createVNode(_component_InputField, {
                                              id: "IsHazmat",
                                              type: "checkbox",
                                              modelValue: fc.isHazmat,
                                              "onUpdate:modelValue": ($event: any) => ((fc.isHazmat) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_119, [
                                            _createVNode(_component_InputField, {
                                              id: "Weight",
                                              modelValue: fc.weight,
                                              "onUpdate:modelValue": ($event: any) => ((fc.weight) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_120, [
                                            _createVNode(_component_InputField, {
                                              id: "Description",
                                              type: "textarea",
                                              modelValue: fc.description,
                                              "onUpdate:modelValue": ($event: any) => ((fc.description) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_121, [
                                            _createVNode(_component_InputField, {
                                              id: "NMFCNumber",
                                              modelValue: fc.nmfcNumber,
                                              "onUpdate:modelValue": ($event: any) => ((fc.nmfcNumber) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_122, [
                                            _createVNode(_component_InputField, {
                                              id: "nmfcClass",
                                              modelValue: fc.nmfcClass,
                                              "onUpdate:modelValue": ($event: any) => ((fc.nmfcClass) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("td", _hoisted_123, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-h-9 tw-w-9 tw-text-slate-600 hover:tw-bg-slate-50",
                                              "aria-label": "Remove freight content",
                                              onClick: ($event: any) => (_ctx.removeFreightContents(containerIdx, fcIdx))
                                            }, [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: "trash",
                                                class: "tw-h-4 tw-w-4"
                                              })
                                            ], 8, _hoisted_124)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ], 8, _hoisted_109)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_125, [
              _createElementVNode("table", _hoisted_126, [
                _cache[66] || (_cache[66] = _createElementVNode("thead", { class: "tw-text-xs tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Quantity"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Package Type"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Hazmat"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Weight"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Description"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "NMFC #"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Class"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" })
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_127, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landFreightContents, (fc, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", _hoisted_128, [
                        _createVNode(_component_InputField, {
                          id: "QuantityLand",
                          modelValue: fc.quantity,
                          "onUpdate:modelValue": ($event: any) => ((fc.quantity) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_129, [
                        _createVNode(_component_InputField, {
                          id: "PackingTypeLand",
                          modelValue: fc.packingType,
                          "onUpdate:modelValue": ($event: any) => ((fc.packingType) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_130, [
                        _createVNode(_component_InputField, {
                          id: "HazmatLand",
                          type: "checkbox",
                          modelValue: fc.isHazmat,
                          "onUpdate:modelValue": ($event: any) => ((fc.isHazmat) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_131, [
                        _createVNode(_component_InputField, {
                          id: "WeightLand",
                          modelValue: fc.weight,
                          "onUpdate:modelValue": ($event: any) => ((fc.weight) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_132, [
                        _createVNode(_component_InputField, {
                          id: "DescLand",
                          modelValue: fc.description,
                          "onUpdate:modelValue": ($event: any) => ((fc.description) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_133, [
                        _createVNode(_component_InputField, {
                          id: "NmfcLand",
                          modelValue: fc.nmfcNumber,
                          "onUpdate:modelValue": ($event: any) => ((fc.nmfcNumber) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_134, [
                        _createVNode(_component_InputField, {
                          id: "ClassLand",
                          modelValue: fc.nmfcClass,
                          "onUpdate:modelValue": ($event: any) => ((fc.nmfcClass) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_135, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-h-9 tw-w-9 tw-text-slate-600 hover:tw-bg-slate-50",
                          "aria-label": "Remove load item",
                          onClick: ($event: any) => (_ctx.removeFreightContents(0, idx))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "trash",
                            class: "tw-h-4 tw-w-4"
                          })
                        ], 8, _hoisted_136)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
      ])
    ])
  ]))
}